import React from "react";
import PageTitle from "../../layout/PageTitle";

const ClientFunctionalities = () => {
  return (
    <div className="container">
      <PageTitle title='Functionalitati Client'/>

      <ul>
        <li>Dashboard
          <ul>
            <li>Grafic masuratori</li>
          </ul>
        </li>
        <li>Lista de cumparaturi</li>
        <li>
          Lista meniuri - un client poate avea mai multe meniuri de la acelasi nutritionist sau de
          la nutritionisti diferiti
          <ul>
            <li>
              <strong>Lista mancaruri</strong>
              <ul>
                <li>Am mancat (imagine + comentariu + rating)</li>
                <li>Nu am mancat (comentariu)</li>
                <li>Adauga in cos de cumparaturi</li>
                <li>
                  <u>
                    * mi-a placut / nu mi-a placut<br/>
                    * Am mancat altceva<br/>
                    * Omite<br/>
                    * Inlocuitor ingrediente<br/>
                    * Inlocuitor masa<br/>
                  </u>
                </li>
              </ul>
            </li>
            <li>
              <strong>Istoric</strong> - odata aplicata o actiune pe o mancare aceasta va trece in istoric
            </li>
            <li>Detalii mancare</li>
          </ul>
        </li>
        <li>Notificari
          <u>
            <ul>
              <li><u><strong>Setari</strong></u></li>
              <li><strong>Notificari legate de chat</strong></li>
              <li><strong>Notificari legate modificarile meniuri</strong></li>
            </ul>
          </u>
        </li>
        <li><u>Chat cu nutritionistul</u>
          <ul>
            <li><u>Chat direct cu nutritionistul</u></li>
            <li><u>Chat per meniu</u></li>
          </ul>
        </li>
        <li>Masuratori + grafic evolutie
          <ul>
            <li>greutate</li>
            <li>poza</li>
            <li>bust</li>
            <li>talie</li>
            <li>brate</li>
            <li>picioare</li>
            <li>solduri</li>
          </ul>
        </li>
        <li>Editare profil</li>
        <li>Adaugare afectiuni</li>
        <li>Adaugare medicamente</li>
        <li>Adaugare alergii</li>
        <li>Adaugare alimente pe care nu le poate manca</li>
        <li><u>Calendar ????</u></li>
        <li><u>Gaseste retete in functie de ce ai in frigider</u></li>
        <li><u>Adaugare ingrediente care nu le pot manca</u></li>
        <li>...</li>
      </ul>

      Mancare = Reteta = Masa
      <br/>
      <strong><u>Ce este subliniat nu este implementat</u></strong>
    </div>
  )
};

export default ClientFunctionalities;